import CommonFunctions from "./CommonFunctions";
import ContentDisposition from "./ContentDisposition";
/*
* jQuery File Download
*/
(($, window) => {
    $.extend({
        fileDownload(fileUrl, options) {
            const settings = $.extend({
                httpMethod: "POST",
                data: null,
            }, options);
            const bodyValue = JSON.stringify(settings.data);
            const contentType = "application/json";
            CommonFunctions.isLoading($("body"));
            fetch(fileUrl, { method: settings.httpMethod, body: bodyValue, headers: { 'Content-Type': contentType } })
                .then((resp) => {
                if (!resp.ok) {
                    throw new Error(resp.statusText);
                }
                let name = null;
                try {
                    name = ContentDisposition.getFilenameFromContentDispositionHeader(resp.headers.get("content-disposition"));
                }
                catch (e) {
                    console.warn(e);
                }
                return { data: resp.blob(), name };
            }).then((data) => {
                data.data.then((blob) => {
                    if (blob.size === 0) {
                        CommonFunctions.isLoadeded($("body"));
                        return;
                    }
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.style.display = "none";
                    a.href = url;
                    if (data.name) {
                        a.download = data.name;
                    }
                    document.body.appendChild(a);
                    a.click();
                    setTimeout(() => {
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(a);
                    }, 1000);
                    CommonFunctions.isLoadeded($("body"));
                    if (settings.successCallback) {
                        settings.successCallback(url);
                    }
                }).catch((error) => {
                    CommonFunctions.isLoadeded($("body"));
                    if (settings.failCallback) {
                        settings.failCallback(error);
                    }
                });
            }).catch((error) => {
                CommonFunctions.isLoadeded($("body"));
                if (settings.failCallback) {
                    settings.failCallback(error);
                }
            });
        }
    });
})(jQuery, this || window);
